import { MidiKey } from "../../../../../../library-js/audio/midi/MidiKey";
import { MusicKey } from "../../../../../../library-js/audio/music/MusicKey";
import { MusicNote } from "../../../../../../library-js/audio/music/MusicNote";
import { InspectorField } from "../../../../../../library-templates/inspector/fields/InspectorField";
import { EnumValue } from "../../../../../../library-templates/inspector/types/EnumValue";

export class KeyExtension
{
  enabled:boolean = false;
  note:MusicNote = new MusicNote();
}

export enum ExportNamingModeType
{
  SamplesExport,
  InstrumentExport, 
  OctaveExport
}

export class SamplesExport
{
  namingFormula = "${name}${index}";
}

export class InstrumentExport
{
  startNote:MusicNote = new MusicNote();
  namingFormula:string = "${name}_${index} - K${min}-${max}+${root}";
  extendToLower:KeyExtension = new KeyExtension();
  extendToHigher:KeyExtension = new KeyExtension();
}

export class OctaveExport
{
  preset:MusicKey[] = [ MusicKey[ "c" ], MusicKey[ "d" ], MusicKey[ "d#" ], MusicKey[ "f" ], MusicKey[ "g" ], MusicKey[ "g#" ], MusicKey[ "a#" ], ];
  startNote:MusicNote = new MusicNote();
}

export class ExportNamingMode
{ 
  exportName = "clip";
  mode = new EnumValue<ExportNamingModeType>( ExportNamingModeType );
  samplesExport = new SamplesExport();
  instrumentExport = new InstrumentExport();
  octaveExport = new OctaveExport();
  
  static definesInspectorFieldsVisibilites( field:InspectorField<any> )
  {
    EnumValue.defineEnumVisibilities( 
      field, "mode", 
      { 
        samplesExport: ExportNamingModeType.SamplesExport,
        instrumentExport: ExportNamingModeType.InstrumentExport, 
        octaveExport: ExportNamingModeType.OctaveExport, 
      }
    );    
  }
}